import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'kt-formly-wrapper-expansion',
    template: `<mat-expansion-panel [expanded]="props['expanded']">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ props.label }}</mat-panel-title>
    <mat-panel-description *ngIf="props?.description">{{ props.description }}</mat-panel-description>
  </mat-expansion-panel-header>

  <ng-template #fieldComponent></ng-template>
</mat-expansion-panel>`,
    imports: [
        MatExpansionModule,
        NgIf,
    ]
})
export class FormlyWrapperExpansionComponent extends FieldWrapper { }
